import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const AboutUsPage = () => {
  return (
    <div style={{color:'white'}}>
    <Container maxWidth="md" style={{ marginTop: '50px', textAlign: 'center' , backgroundColor:'darkslategray', height:'100%', paddingTop:'40px',paddingBottom:'40px', borderRadius:'10px'}}>
      <Typography variant="h4"  style={{fontFamily: 'Cinzel Decorative',fontSize:'3rem',color:'goldenrod'}}  gutterBottom>
        About Taqwa24/7
      </Typography>
      <Typography variant="body1" style={{fontFamily: 'Cinzel Decorative',fontWeight:'normal'}} paragraph>
        Welcome to Taqwa24/7, your trusted online Islamic library dedicated to providing valuable
        resources and knowledge for spiritual growth and enlightenment.
      </Typography>
      <Typography variant="body1" style={{fontFamily: 'Cinzel Decorative',fontWeight:'normal'}} paragraph>
        Our mission is to offer a diverse collection of Islamic literature, educational materials,
        and spiritual guidance to support individuals on their journey towards a deeper understanding
        of Islam and a closer connection with Allah.
      </Typography>
      <Typography variant="body1" style={{fontFamily: 'Cinzel Decorative',fontWeight:'normal'}} paragraph>
        At Taqwa24/7, we strive to bring you authentic content, including Quranic studies, Hadith,
        Islamic history, and more. Our goal is to create a platform where you can explore, learn,
        and strengthen your faith.
      </Typography>
      <Typography variant="body1" style={{fontFamily: 'Cinzel Decorative',fontWeight:'normal'}} paragraph>
        Feel free to browse through our extensive library, and may your journey towards knowledge and
        piety be blessed. Thank you for choosing Taqwa24/7 as your source for Islamic wisdom and
        enlightenment.
      </Typography>
      <Typography variant="body2" style={{fontFamily: 'Cinzel Decorative',fontWeight:'normal',color:'goldenrod'}}>
        For any inquiries or feedback, please contact us at: info@taqwa247.com
      </Typography>
    </Container>
    </div>
  );
};

export default AboutUsPage;
